import { Component } from '@angular/core';
import { Location } from '@angular/common';


@Component({
  selector: 'shared-arrow-back',
  standalone: true,
  imports: [],
  templateUrl: './arrow-back.component.html',
  styleUrl: './arrow-back.component.css'
})
export class ArrowBackComponent {
  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
